<template>
    <nav v-if="breadcrumbs.length" class="flex text-gray-700" aria-label="Breadcrumb">
        <ol class="flex flex-wrap">
            <!-- В мобильной версии показываем только предыдущую страницу -->
            <template v-if="!showAllBreadcrumbs">
                <li class="mb-3">
                    <div class="flex items-center leading-tight">
                        <Link :href="route('home')" class="leading-tight">
                            <IconHomeFilled class="w-5 h-5 -mt-0.5" :style="{ fill: color }"/>
                        </Link>
                        <IconAngleLeft class="w-3 h-3 text-gray-400 mx-1 rotate-180"/>
                    </div>
                </li>
                <li class="mb-3">
                    <div @click.prevent="showAllBreadcrumbs = true"
                         class="rounded h-[18px] w-[40px] flex items-center justify-center gap-1 me-2"
                         :style="{ backgroundColor: color }">
                        <div v-for="i in 3" :key="i" class="h-[5px] w-[5px] rounded-full bg-gray-500"></div>
                    </div>
                </li>
            </template>
            <template v-if="showAllBreadcrumbs">
                <li v-for="(breadcrumb, key) in breadcrumbs" :key="key" class="mb-3">
                    <div class="flex items-center">
                        <IconAngleLeft v-if="key !== 0" class="w-3 h-3 text-gray-400 mx-1 rotate-180"/>
                        <Link v-if="key !== breadcrumbs.length - 1" :href="breadcrumb.url"
                              class="mt-[1px] text-xs font-bold md:hover:text-navHoverColor transition cursor-pointer leading-tight">
                            {{ breadcrumb.title }}
                        </Link>
                        <span v-else class="mt-[1px] text-xs font-bold cursor-default leading-tight">
                            {{ breadcrumb.title }}
                        </span>
                    </div>
                </li>
            </template>
            <template v-else>
                <li v-if="currentBreadcrumb" class="mb-3" @click.prevent="showAllBreadcrumbs = true">
                    <div class="flex items-center gap-1 leading-tight">
                        <IconAngleLeft class="w-3 h-3 text-gray-400 mx-1 rotate-180"/>
                        <span
                            class="max-md:max-w-[225px] truncate mt-[2px] text-xs font-medium md:hover:text-navHoverColor transition leading-tight">
                            {{ currentBreadcrumb.title }}
                        </span>
                    </div>
                </li>
            </template>
        </ol>
    </nav>
</template>

<script>
import {ref, computed, onMounted, onBeforeUnmount} from 'vue';
import {Link, usePage} from '@inertiajs/vue3';
import IconAngleLeft from '@js/components/Icons/IconAngleLeft.vue';
import {useThemeStore} from '@js/store/ThemeStore.js';
import IconHomeFilled from "@js/components/Icons/IconHomeFilled.vue";

export default {
    name: "Breadcrumbs",
    components: {IconHomeFilled, Link, IconAngleLeft},
    props: {
        color: {
            required: false,
            default: '#ffba00',
        }
    },
    setup(props) {
        const themeStore = useThemeStore();
        const page = usePage();

        const breadcrumbs = ref(page.props.breadcrumbs || []);
        const showAllBreadcrumbs = ref(true);

        const currentBreadcrumb = computed(() => {
            return breadcrumbs.value.at(-1) ?? null;
        });

        const updateBreadcrumbsMode = () => {
            if (typeof window !== 'undefined') {
                showAllBreadcrumbs.value = !window.matchMedia('(max-width: 1024px)').matches;
            }
        };

        onMounted(() => {
            updateBreadcrumbsMode();
            window.addEventListener("resize", updateBreadcrumbsMode);
        });

        onBeforeUnmount(() => {
            window.removeEventListener("resize", updateBreadcrumbsMode);
        });

        return {
            themeStore,
            breadcrumbs,
            showAllBreadcrumbs,
            currentBreadcrumb,
            color: props.color,
        };
    }
};
</script>
